const USER_LOGOUT = 'USER_LOGOUT';
export default USER_LOGOUT;
